module.exports = __webpack_public_path__ + "media/images/home/feature/staff_requestlist-ee4150936abde7e60d89946c0fb1dd9b.png";